import { Injectable } from '@angular/core';
import {
ChangePassword,
Login,
MFAAutheticate,
NewUser,
User,
} from '../models/persons.model';
import { BehaviorSubject, Observable, throwError, of } from 'rxjs';
import {
HttpClient,
HttpErrorResponse,
HttpHeaders,
} from '@angular/common/http';
import { catchError, map, tap } from 'rxjs/operators';
import { IMovidaUnauthorize } from './abstractions.service';
import { LoganService } from './logan.service';
import { environment } from 'src/environments/environment';
import { UserLogan } from '../models/userLogan';
import { Router } from '@angular/router';

import * as CryptoJS from 'crypto-js';

@Injectable({
providedIn: 'root',
})
export class AuthService extends LoganService implements IMovidaUnauthorize {
headers = new HttpHeaders().set('Content-Type', 'text/plain; charset=utf-8');
requestOptions: Object = {
headers: this.headers,
responseType: 'text',
withCredentials: true,
};

private currentUserSubject: BehaviorSubject<User>;
public currentUser: Observable<User>;
public isUserAdmin: boolean = false;
public isUserAll: boolean = false;
public email: string = '';
private apiServerUrl = environment.loganConfig.url;
activeUsername = '';

constructor(http: HttpClient, private router: Router) {
    super(http, 'auth');
    let current = this.decrypt(localStorage.getItem('currentUser'));
    let user = current != null && current != '' ? JSON.parse(current) : null;
    try {
      this.getUserType(JSON.parse(current));
    } catch (error: any) {}

    this.currentUserSubject = new BehaviorSubject<User>(user);
    this.currentUser = this.currentUserSubject.asObservable();
  }

  public get currentUserValue(): User {
    return this.currentUserSubject.value;
  }

  updatePermissions(permissions: any, userId: any) {
    return this.http.post<any>(
      this.getUrl(`updatePermissions/${userId}`),
      permissions
    );
  }

  getUserType(user: any) {
    this.isUserAdmin = false;
    this.isUserAll = false;
    if (user != null && user != undefined) {
      if (user?.screensAllowed != null) {
        let screensSplit = user?.screensAllowed
          .replace('**', 'admin')
          .replace('*', 'all')
          .split(';');
        if (screensSplit.includes('admin')) {
          this.isUserAdmin = true;
        }
        if (screensSplit.includes('all')) {
          this.isUserAll = true;
        }
      }
    }
  }

  status(): Observable<any> {
    let url = this.getUrl('status').replace('api-', '');
    if (url.search('.dev') > -1) {
      url = url.replace('/status', '/devStatus');
    }
    return this.http.post(url, {
      withCredentials: true,
    });
  }

  authenticate(token: string, recaptchaToken: string): Observable<User> {
    return this.http
      .post<any>(
        this.getUrl('authenticate'),
        new MFAAutheticate({
          token: token,
          username: this.activeUsername,
          recaptchaToken,
        }),
        { withCredentials: true }
)
.pipe(
        map((data) => {
          let user = new User(data);
          if (user && user.token) {
            localStorage.setItem(
              'currentUser',
              this.encrypt(JSON.stringify(user))
            );
            this.getUserType(user);

            this.currentUserSubject.next(user);
          }

          return user;
        })
      );
  }

  loginMFA(
    username: string,
    password: string,
    recaptchaToken: string
  ): Observable<any> {
    this.activeUsername = username;
    return this.http.post(
      this.getUrl('login-mfa'),
      new Login(username, password, recaptchaToken),
      { withCredentials: true }
    );
  }

  login(
    username: string,
    password: string,
    recaptchaToken: string
  ): Observable<User> {
    return this.http
      .post<any>(
        this.getUrl('login'),
        new Login(username, password, recaptchaToken)
)
.pipe(
        map((data) => {
          let user = new User(data);
          if (user && user.token) {
            localStorage.setItem(
              'currentUser',
              this.encrypt(JSON.stringify(user))
            );
            this.router.navigate(['']);
          }
          return user;
        })
      );
  }

  loginNoMfa(data : any) {
      let user = new User(data);
      if (user && user.token) {
        localStorage.setItem(
          'currentUser',
          this.encrypt(JSON.stringify(user))
        );
        this.router.navigate(['']);
      }
  }

  logout(): Observable<any> {
    var url = this.getUrl('logout');
    return this.http.get<any>(url).pipe(
      tap(() => {
        this.disallow().subscribe(() => {
          this.router.navigate(['/auth/login']);
        });
      }),
      catchError((erro: HttpErrorResponse): Observable<any> => {
        this.disallow().subscribe(() => {
          this.router.navigate(['/auth/login']);
        });
        return of(true);
      })
    );
  }

  changePassword(loginChangePassword: ChangePassword) {
    return this.http.post(
      this.getUrl('changePassword'),

      loginChangePassword,
      { withCredentials: true }
    );
  }
  createNewUser(newUser: NewUser) {
    return this.http.post(
      this.getUrl('createNewUser'),

      newUser.toJson,
      { withCredentials: true }
    );
  }
  emailAvaliableCheck(email: string) {
    return this.http.post(
      this.getUrl('emailAvaliableCheck'),

      email,
      { withCredentials: true }
    );
  }

  disallow(): Observable<any> {
    localStorage.removeItem('currentUser');
    localStorage.removeItem('currentUserScreen');
    this.currentUserSubject.next(null!);
    return of(true);
  }

  public getUserScreens(email: string): Observable<any> {
    return this.http.post<any>(
      `${this.apiServerUrl}/api/auth/getUserScreens`,
      email,
      this.requestOptions
    );
  }
  public resetPassword(userId: number): Observable<any> {
    return this.http.get<any>(
      `${this.apiServerUrl}/api/auth/resetPassword/${userId}`,
      this.requestOptions
    );
  }
  public getAllUserScreens(): Observable<any> {
    return this.http.get<any>(
      `${this.apiServerUrl}/api/auth/getAllUserScreens`
    );
  }
  public updateUserScreens(user: UserLogan): Observable<UserLogan> {
    return this.http.post<UserLogan>(
      `${this.apiServerUrl}/api/auth/updateUserScreens`,
      user,
      this.requestOptions
    );
  }
  encrypt(item: string): string {
    try {
      return CryptoJS.AES.encrypt(item, environment.keyCrypto).toString();
    } catch (error) {
      return '';
    }
  }
  decrypt(item: string | null): string {
    if (item != null) {
      try {
        let a = CryptoJS.AES.decrypt(item, environment.keyCrypto).toString(
          CryptoJS.enc.Utf8
        );
        return a ? a : '';
      } catch (error) {
        return '';
      }
    }
    return '';
  }
}
